const release = "wasserski-erfurt.r145-heads-master-0-ge347199"

// @ts-ignore
if (release && typeof context !== "undefined") {
    context.response.header("X-Release", release)
}

module.exports = {
    release,
}
